/**
 * @package dto
 * @author Artem Ilinykh devsinglesly@gmail.com
 * @class CreateCounterData
 */
import { AbstractData } from '@/modules/backend/Dto/AbstractData';

export class CreateCounterData extends AbstractData {
  public accountId!: number;

  public serialNumber!: {
    counter: string;
    device: string;
  };

  public initialValue!: number;

  public channel!: number;

  public resourceId!: number;

  public modelId!: number;

  public stamp!: string;

  public checkInterval!: {
    last: string|Date;
    next: string|Date;
  };

  public note?: string;
}
